import React from 'react';
import { CssBaseline, ThemeProvider, StyledEngineProvider } from '@mui/material';
import themeMod from './../../styles/theme/MUItheme'
import './Dashboard.scss';

class Dashboard extends React.Component {
    render() {
        const { position, children, hideScrollbar = false } = this.props;

        return (
            <StyledEngineProvider injectFirst>
                <ThemeProvider theme={themeMod}>
                    <CssBaseline />
                    <div className="dashboard-root" style={{ position: position, overflow: hideScrollbar ? 'hidden' : 'none' }}>
                        <main>{children}</main>
                    </div>
                </ThemeProvider>
            </StyledEngineProvider>
        );
    }
}

export default Dashboard;